import { useContext } from "react";

import {
  useGetAgenciesGeographiesAgenciesGet,
  useGetLegalEntityLegalEntitiesGet,
} from "@/services/2/react-query/hooks";

import { LegalEntityContext } from "../legal-entity-context";
import { MultiSelectDropdown } from "../multiselect-dropdown";

type MultiAgencySelectorProps = {
  selectedAgencies: string[];
  onChange: (newValues: string[]) => void;
};

export const MultiAgencySelector = ({ selectedAgencies, onChange }: MultiAgencySelectorProps) => {
  const legalEntityContext = useContext(LegalEntityContext);

  const { data: agencies } = useGetAgenciesGeographiesAgenciesGet(
    {
      query: { legal_entity_uuids: legalEntityContext ? [legalEntityContext] : [] },
    },
    [legalEntityContext || "all"],
    {
      staleTime: 60 * 60 * 1000, // 1 hour
    }
  );
  const { data } = useGetLegalEntityLegalEntitiesGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });

  const getLegalEntityName = (legalEntityUuid: string) => {
    const legalEntity = data?.find(le => le.uuid === legalEntityUuid);
    return legalEntity ? legalEntity.name : undefined;
  };

  return (
    <MultiSelectDropdown
      name="agencies"
      label="Agence"
      pluralLabel="Agences"
      options={(agencies || []).map(agency => ({
        value: agency.agency_uuid,
        label: agency.agency_name,
        description: getLegalEntityName(agency.legal_entity_uuid),
      }))}
      values={selectedAgencies}
      onChangeValues={onChange}
    />
  );
};
